export default __webpack_public_path__ + "static/media/inventory-export.46c626b7.png";